import { truncateAddress } from "../../utils/string";

export enum ClaimError {
  NotAllowlistedAsContributor = "NotAllowlistedAsContributor",
  ClaimingAddressAlreadyHasToken = "ClaimingAddressAlreadyHasToken",
  NoMoreAvailableTokens = "NoMoreAvailableTokens",
  ExpiredToken = "ExpiredToken",
  InvalidKudosClaimInput = "InvalidKudosClaimInput",
  InvalidCaptcha = "InvalidCaptcha",
}

export const formattedErrorMessage = (
  error: ClaimError | null,
  address: string,
  discordDisplayName?: string,
) => {
  const formattedAddress = truncateAddress(address);
  switch (error) {
    case ClaimError.NotAllowlistedAsContributor:
      return discordDisplayName
        ? `Your Discord account (${discordDisplayName}) is not allowlisted 🥺`
        : `Your wallet (${formattedAddress}) is not allowlisted 🥺`;
    case ClaimError.ClaimingAddressAlreadyHasToken:
      return `You've already minted this kudos 🤗`;
    case ClaimError.NoMoreAvailableTokens:
      return `This kudos has finished minting 🥺`;
    case ClaimError.ExpiredToken:
      return `The claim period for this kudos expired 🥺`;
    case ClaimError.InvalidKudosClaimInput:
      return `${formattedAddress} is not a valid address 🥺`;
    case ClaimError.InvalidCaptcha:
      return "Captcha not valid 🥺";
    default:
      return "";
  }
};
